import {useCallback, useRef, useState} from 'react';

export default function usePendingHandler<T extends (...values: Array<any>) => Promise<void>>(
  handler: T,
  errorHandler?: (error: unknown, ...values: Array<any>) => void
): [T, boolean] {
  const isPending = useRef(false);
  const [isPendingUi, setIsPendingUi] = useState(false); // state 트래킹용

  const handlerWrapper = useCallback(
    async (...values: Array<any>) => {
      if (isPending.current) {
        return;
      }

      isPending.current = true;
      setIsPendingUi(true);
      try {
        await handler(...values);
      } catch (e) {
        if (errorHandler) {
          errorHandler(e, ...values);
        }
      } finally {
        isPending.current = false;
        setIsPendingUi(false);
      }
    },
    [errorHandler, handler, isPending]
  );

  return [handlerWrapper as T, isPendingUi];
}
